import React from "react";
import { Container, Typography, Box, useTheme, useMediaQuery } from "@mui/material";
import { IMG_ETHNIC_IMAGE_1 as AboutImage } from "./imageConfig";

const About = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  return (
    <Container
      maxWidth="md"
      sx={{
        py: isMobile ? 8 : 14,
        px: isMobile ? 2 : 3
      }}
    >
      <Typography
        variant="h3"
        align="center"
        sx={{
          fontWeight: 100,
          lineHeight: isMobile ? "1.5rem" : "2rem",
          fontFamily: '"Playfair Display", serif',
          textTransform: "uppercase",
          mt: isMobile ? 15 : 15,
          mb: isMobile ? 10 : 10,
          fontSize: isMobile ? "1.5rem" : isTablet ? "2rem" : "2.5rem"
        }}
      >
        ABOUT DAINA
      </Typography>

      <Box
        component="img"
        src={AboutImage}
        alt="About Daina"
        sx={{
          width: "100%",
          mb: isMobile ? 3 : 4,
          height: isMobile ? 250 : isTablet ? 350 : 400,
          objectFit: "cover",
        }}
      />

      <Typography
        variant="body1"
        align="center"
        sx={{
          mb: isMobile ? 3 : 4,
          color: "text.secondary",
          fontSize: isMobile ? "0.9rem" : "1rem"
        }}
      >
        Founded in 2026, DAINA is a contemporary Indian ethnic wear label designed
        for modern life. We create elevated essentials that blend comfort,
        craftsmanship, and timeless elegance. Each piece is made to move effortlessly
        from everyday wear to special occasions with ease.
      </Typography>

      <Box sx={{ textAlign: "center", mt: isMobile ? 4 : 6 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 500,
            mb: 1,
            fontSize: isMobile ? "1.25rem" : "1.5rem"
          }}
        >
          Our Mission
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            maxWidth: 600,
            mx: "auto",
            fontSize: isMobile ? "0.9rem" : "1rem"
          }}
        >
          To reimagine Indian fashion with softness, intention, and authenticity.
          We believe mindful design should feel luxurious, celebrate culture, and
          leave a lighter footprint on the world.
        </Typography>
      </Box>

      <Box sx={{ textAlign: "center", mt: isMobile ? 4 : 6 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 500,
            mb: 1,
            fontSize: isMobile ? "1.25rem" : "1.5rem"
          }}
        >
          Crafted with Intention
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            maxWidth: 600,
            mx: "auto",
            fontSize: isMobile ? "0.9rem" : "1rem"
          }}
        >
          We design with purpose, focusing on feel, fit, and versatility. Every DAINA
          piece is created to be effortless, expressive, and lasting — something you
          can reach for time and again.
        </Typography>
      </Box>

      <Box sx={{
        textAlign: "center",
        mt: isMobile ? 6 : 8,
        mb: isMobile ? 4 : 0
      }}>
        <Typography
          variant="h6"
          sx={{
            fontStyle: "italic",
            fontSize: isMobile ? "1rem" : "1.25rem"
          }}
        >
          "Wear what feels good, and does good."
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          mt={1}
          sx={{
            fontSize: isMobile ? "0.8rem" : "0.9rem"
          }}
        >
          — The Founders
        </Typography>
      </Box>
    </Container>
  );
};

export default About;
